// extracted by mini-css-extract-plugin
export default {"horizontalScroller":"QuickView-module_horizontalScroller-J6hWz","disableScrolling":"QuickView-module_disableScrolling-VXIIz","singleAsinMode":"QuickView-module_singleAsinMode-RjpR6"};